import { css } from 'styled-components';
import { white } from './colors';

export const borderlessFocusStyles = css`
  &:focus {
    outline: 1px dotted ${white};
    outline: 1px auto -webkit-focus-ring-color;
  }
`;
